<template>
  <div class="mb-5">
    <h4 class="mt-3">
      {{ $t("CHECKED_OPERATORS") }}
    </h4>
    <v-row class="t-head">
      <v-col>{{ $t("NAME") }}</v-col>
      <v-col>{{ $t("ACTIONS") }}</v-col>
    </v-row>
    <template
      v-for="operator in _.filter(routemap.operators, {
        active: true
      })"
    >
      <v-row class="row border-bottom" v-bind:key="'o' + operator.id">
        <v-col class="t-row"
          >{{ operator.firstName }} {{ operator.lastName }}</v-col
        >
        <v-col class="t-row">
          <template v-if="['Admin', 'Manager'].includes(user.role)">
            <span
              class="btn btn-block btn-danger"
              @click="$emit('checkout-operator', operator)"
            >
              {{ $t("FINISH_WORK_ON_THIS_ROUTE_MAP") }}
            </span>
          </template>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: "CheckedOperatorsSection",
  props: {
    routemap: {
      required: true,
      type: Object
    },
    user: {
      required: true,
      type: Object
    }
  }
};
</script>
